import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import About from './components/About';
import Reviews from './components/Reviews';
import Contact from './components/Contact';
import StickyEstimate from './components/StickyEstimate';
import GetFreeEstimateButton from './components/GetFreeEstimateButton';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Services />
      <Portfolio />
      <About />
      <Reviews />
      <Contact />
      <StickyEstimate />
      <GetFreeEstimateButton />
    </div>
  );
}

export default App;